module.exports = __webpack_public_path__ + "img/btn_servik.c87c4e3f.svg";